import { edgeApi } from '@lib/apiClients.ts';
import { microServicesRoutes } from '@constants';
import { type ApiResponse, type CalendarResponse } from '@types';
import { handleError } from '@utils/handleAPIError.ts';

async function getCalendlyApi (userId: string, cache: boolean): Promise<ApiResponse<CalendarResponse>> {
  try {
    const sessions = await edgeApi.get<CalendarResponse>(`${microServicesRoutes.edge.get.calendar.getSessions}/${userId}`, {
      params: { cache },
    });
      
    return {
      data: sessions.data,
      success: true
    };

  } catch (e) {
    return handleError<CalendarResponse>('Error getting Calendly sessions', e, 'Edge getCalendar');
  }
}

export default getCalendlyApi;